import store from "../../../../store";
import { has } from "../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canWaitReceiveCustoms: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                result = Object.keys(record.request).some(key => record.request[key].some(d => ["draft", "reEdit"].includes(d.refStatus?.key)));
            }
            return result;
        },
        canWaitApproveCenter: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forCustoms" })) {
                result = Object.keys(record.request).some(
                    key =>
                        record.request[key].some(d => ["waitReceiveCustoms"].includes(d.refStatus?.key)) &&
                        record.request[key][0]?.refDepartment &&
                        record.request[key][0]?.refDepartment?.id === userInfo?.refDepartment?.id
                );
            }
            return result;
        },
        canWaitDocCustoms: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forCenter" })) {
                result = Object.keys(record.request).some(key => record.request[key].some(d => ["waitApproveCenter"].includes(d.refStatus?.key)));
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info.user;
            if (has({ menuContext, key: "forCustoms" })) {
                const request = Object.keys(record.request)
                    .flatMap(key => record.request[key] || [])
                    .filter(d => ["reEdit", "waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"].includes(d.refStatus?.key));
                result =
                    request.length > 0 &&
                    request.every(d => {
                        return (
                            ["waitDocCustoms"].includes(d.refStatus?.key) && d.refDepartment && d.refDepartment?.id === userInfo?.refDepartment?.id
                        );
                    });
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forRequest" })) {
                result =
                    Object.keys(record.request).some(key =>
                        record.request[key].some(d => {
                            return ["waitReceiveCustoms"].includes(d.refStatus?.key);
                        })
                    ) || result;
            }
            if (has({ menuContext, key: "forCustoms" })) {
                result =
                    Object.keys(record.request).some(
                        key =>
                            record.request[key].some(d => ["waitApproveCenter"].includes(d.refStatus?.key)) &&
                            record.request[key][0]?.refDepartment &&
                            record.request[key][0]?.refDepartment?.id === userInfo?.refDepartment?.id
                    ) || result;
            }
            if (has({ menuContext, key: "forCenter" })) {
                result =
                    Object.keys(record.request).some(key =>
                        record.request[key].some(d => {
                            if (d.refRequestDoc?.key === "2") {
                                return false;
                            }
                            return ["waitDocCustoms"].includes(d.refStatus?.key);
                        })
                    ) || result;
            }
            return result;
        },
        canCancel: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                result = Object.keys(record.request).some(key => record.request[key].some(d => ["reEdit"].includes(d.refStatus?.key)));
            }
            return result;
        }
    };
};
